// React
import React, { Fragment } from "react";
import PropTypes from "prop-types";
// i18n
import { withNamespaces } from "react-i18next";
// Styles
import styles from "./TableRow.css";

function checkClaim(claims, claimToCheck) {
  if (!claims || claims.length === 0) {
    return false;
  }

  const foundedClaim = claims.find((claimItem) => claimItem.type === claimToCheck);

  return foundedClaim && foundedClaim.value === "true";
}

function TableRow({ handleClick, row, t, claims }) {
  const hasRightForManualAssignment = checkClaim(
    claims,
    `base.ltsregister.bookings.function.allowmanualbookings`
  );

  const buttonBookingDetails = (
    <button
      type="button"
      title={t(`modules.localization.register.authenticated.bookings.details`)}
      style={styles.buttonIcon}
      onClick={handleClick({ candidate: row })}
    >
      <i className="fa fa-lg fa-user txt-color-blue" />
    </button>
  );

  let buttonManualAssignment = ``;
  if (hasRightForManualAssignment) {
    buttonManualAssignment = (
      <button
        type="button"
        title={t(`modules.localization.register.authenticated.usersList.manualAssignment`)}
        style={styles.buttonIcon}
        onClick={handleClick({
          candidate: row,
          assign: true
        })}
      >
        <i className="fa fa-lg fa-calendar-check-o txt-color-blue" />
      </button>
    );
  }

  return (
    <tr className={row.id % 2 === 0 ? `even` : `odd`} role="row">
      {Object.keys(row).map((key) => (
        <td className="expand" key={key} style={styles.tableRow}>
          {key !== `options` ? (
            row[key]
          ) : (
            <>
              {buttonBookingDetails}
              {buttonManualAssignment}
            </>
          )}
        </td>
      ))}
    </tr>
  );
}

TableRow.propTypes = {
  claims: PropTypes.array.isRequired,
  handleClick: PropTypes.func.isRequired,
  row: PropTypes.object.isRequired,
  t: PropTypes.func
};

export default withNamespaces()(TableRow);
